import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import invice from '../../../Assets/invoice.svg'
import close from "../../../../src/Assets/close icon.svg";
import Cookies from "js-cookie";

const AWR = ({ product, onClose }) => {
  const [address, setAddress] = useState('');
  const [query, setQuery] = useState('');
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [submissionError, setSubmissionError] = useState(false);
  const [purchaseFrom, setPurchaseFrom] = useState('');

  const handlePurchaseFromChange = (e) => {
    setPurchaseFrom(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleQueryChange = (e) => {
    setQuery(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const token = Cookies.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionError(false);
    setSubmissionSuccess(false);

    const formData = new FormData();
    formData.append('productId', product.productID);
    formData.append('customerId', product.customerId);
    formData.append('address', address);
    formData.append('query', query);
    formData.append('purchaseFrom', purchaseFrom);

    if (file) {
      formData.append('file', file);
    }

    try {
      await axios.post(`${API_BASE_URL}/awr/submit-query`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": token ? `Bearer ${token}` : "",
        },
      });
      setSubmissionSuccess(true);
      setAddress('');
      setQuery('');
      setPurchaseFrom(''); 
      setFile(null);
    } catch (error) {
      console.error('Error submitting query:', error);
      setSubmissionError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const dealerOptions = [
    { value: '', label: 'Select Your Dealer' },
    { value: 'PIONEER_COMPUTER', label: 'Pioneer Computer' },
    { value: 'MICRO_INFOSOLUTIONS', label: 'Micro Infosolutions Private Limited' },
    { value: 'JALAN_DISTRIBUTORS', label: 'Jalan Distributors' },
    { value: 'HITECH_SOLUTIONS', label: 'Hitech Solutions' },
    { value: 'GROWTH_PARTNERS', label: 'Growth Partners' },
    { value: 'DOCKET_CARE_SYSTEMS', label: 'Docket Care Systems' },
    { value: 'COMPUTER_PROFESSIONAL', label: 'Computer Professional' },
    { value: 'ALL_FORTECH', label: 'All Fortech' },
    { value: 'FORTECH', label: 'Fortech' },
    { value: 'SATYA_IT_SOLUTION', label: 'Satya IT Solution' },
    { value: 'VISION_INDIA', label: 'Vision India' },
    { value: 'COMTECH_SOLUTION_POINT', label: 'Comtech Solution Point' },
    { value: 'DIGITAL_EQUIPMENTS', label: 'Digital Equipments' },
    { value: 'CREATIVE_IT_HUB', label: 'Creative IT Hub' },
    { value: 'SRK_ENTERPRISES', label: 'SRK Enterprises' },
    { value: 'UNIVERSAL', label: 'Universal' },
  ];

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-2 sm:p-4 lg:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-2xl w-full max-w-sm sm:max-w-lg md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl relative max-h-[98vh] sm:max-h-[95vh] md:max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with Close Button */}
        <div className="relative flex-shrink-0 p-4 sm:p-6 lg:p-8 border-b border-gray-200">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 sm:top-4 sm:right-4 lg:top-6 lg:right-6 text-gray-400 hover:text-gray-600 transition-colors duration-200 z-10"
            aria-label="Close modal"
          >
            <img
              src={close}
              alt="Close"
              className="h-6 w-6 sm:h-8 sm:w-8 lg:h-10 lg:w-10 object-contain"
            />
          </button>

          {/* Responsive Headers */}
          <div className="pr-8 sm:pr-12 lg:pr-16">
            {/* Mobile: Stacked headers */}
            <div className="block lg:hidden space-y-2">
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 text-center leading-tight">
                Product Details
              </h3>
              <h4 className="text-base sm:text-lg font-semibold text-[#1C50A3] text-center leading-tight">
                Advance Warranty Replacement (AWR)
              </h4>
            </div>
            
            {/* Desktop: Side by side headers */}
            <div className="hidden lg:flex justify-between items-center">
              <h3 className="text-2xl xl:text-3xl font-bold text-gray-800">Product Details</h3>
              <h4 className="text-xl xl:text-2xl font-semibold text-[#1C50A3]">AWR Request</h4>
            </div>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          <div className="p-4 sm:p-6 lg:p-8">
            {/* Main Content - Responsive Layout */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 xl:gap-12">
              
              {/* Left side: Product Details */}
              <div className="flex-1 lg:max-w-md xl:max-w-lg">
                <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
                  <h5 className="text-lg font-semibold text-gray-800 mb-4 border-b border-gray-200 pb-2">
                    Product Information
                  </h5>
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Customer ID:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">{product.customerId}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Product ID:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">{product.productID}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Product Name:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right font-medium">{product.productName}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Serial No:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">{product.serialNo}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Model No:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">{product.modelNo}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Purchase Date:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">
                        {new Date(product.purchaseDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Warranty Period:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">{product.warrantyPeriod}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:justify-between">
                      <span className="font-medium text-[#1C50A3] text-sm sm:text-base">Expiry Date:</span>
                      <span className="text-gray-700 text-sm sm:text-base sm:text-right">
                        {new Date(product.expiryDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </span>
                    </div>
                  </div>
                  
                  {/* Invoice Button */}
                  <div className="mt-6 pt-4 border-t border-gray-200">
                    <button
                      onClick={() => window.open(`${API_BASE_URL}${product.invoice}`, '_blank')}
                      className="w-full sm:w-auto border-2 border-[#1C50A3] text-[#1C50A3] py-2.5 px-4 sm:px-6 rounded-lg hover:bg-[#1C50A3] hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center text-sm sm:text-base font-medium shadow-sm hover:shadow-md"
                    >
                      <img
                        src={invice}
                        alt="Invoice Icon"
                        className="h-4 w-4 sm:h-5 sm:w-5 mr-2"
                      />
                      View Invoice
                    </button>
                  </div>
                </div>
              </div>

              {/* Responsive Divider */}
              <div className="block lg:hidden border-t border-gray-300"></div>
              <div className="hidden lg:block w-px bg-gray-300"></div>

              {/* Right side: Form */}
              <div className="flex-1">
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6">
                  <h5 className="text-lg font-semibold text-gray-800 mb-6 border-b border-gray-200 pb-2">
                    AWR Request Form
                  </h5>
                  
                  <form onSubmit={handleSubmit} className="space-y-6">
                    
                    {/* Purchase From Dropdown */}
                    <div>
                      <label htmlFor="purchaseFrom" className="block font-semibold text-gray-700 mb-2 text-sm sm:text-base">
                        Purchase From <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="purchaseFrom"
                        value={purchaseFrom}
                        onChange={handlePurchaseFromChange}
                        className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1C50A3] focus:border-transparent text-sm sm:text-base bg-white transition-all duration-200"
                        required
                      >
                        {dealerOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Address Field */}
                    <div>
                      <label htmlFor="address" className="block font-semibold text-gray-700 mb-2 text-sm sm:text-base">
                        Replacement Address <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="address"
                        value={address}
                        onChange={handleAddressChange}
                        placeholder="Enter your complete replacement address..."
                        className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1C50A3] focus:border-transparent h-20 sm:h-24 text-sm sm:text-base resize-none transition-all duration-200"
                        required
                      />
                    </div>

                    {/* Query Field */}
                    <div>
                      <label htmlFor="query" className="block font-semibold text-gray-700 mb-2 text-sm sm:text-base">
                        Describe Your Issue <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="query"
                        value={query}
                        onChange={handleQueryChange}
                        placeholder="Please describe the issue requiring replacement..."
                        className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1C50A3] focus:border-transparent h-24 sm:h-28 text-sm sm:text-base resize-none transition-all duration-200"
                        required
                      />
                    </div>

                    {/* File Upload */}
                    <div>
                      <label htmlFor="file" className="block font-semibold text-gray-700 mb-2 text-sm sm:text-base">
                        Upload Image (Optional)
                      </label>
                      <div className="relative">
                        <input
                          id="file"
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                          className="w-full border-2 border-dashed border-gray-300 rounded-lg p-4 sm:p-6 text-sm sm:text-base focus:outline-none focus:border-[#1C50A3] transition-colors cursor-pointer hover:border-gray-400"
                        />
                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                          {!file && (
                            <div className="text-center text-gray-500">
                              <svg className="mx-auto h-8 w-8 sm:h-10 sm:w-10 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                              <span className="text-xs sm:text-sm">Click to upload image</span>
                            </div>
                          )}
                        </div>
                      </div>
                      {file && (
                        <p className="mt-2 text-sm text-green-600 bg-green-50 p-2 rounded border border-green-200">
                          ✓ File selected: {file.name}
                        </p>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="pt-4">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full bg-[#1C50A3] text-white py-3 sm:py-4 px-6 sm:px-8 rounded-lg shadow-lg hover:bg-[#144080] transition-all duration-300 ease-in-out text-sm sm:text-base font-semibold ${
                          isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-xl hover:scale-[1.02]'
                        }`}
                      >
                        {isSubmitting ? (
                          <div className="flex items-center justify-center">
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Submitting AWR Request...
                          </div>
                        ) : (
                          'Submit AWR Request'
                        )}
                      </button>
                    </div>

                    {/* Status Messages */}
                    {submissionSuccess && (
                      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                        <div className="flex items-center">
                          <svg className="h-5 w-5 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          <p className="text-green-700 font-medium text-sm sm:text-base">
                            AWR request submitted successfully! We'll process your request soon.
                          </p>
                        </div>
                      </div>
                    )}
                    
                    {submissionError && !isSubmitting && (
                      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                        <div className="flex items-center">
                          <svg className="h-5 w-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          <p className="text-red-700 font-medium text-sm sm:text-base">
                            Failed to submit AWR request. Please check your connection and try again.
                          </p>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AWR;
